export const config = {
  // apiUrl: "https://cadenabackend.iworklab.com/api/v1",
  // baseUrl: "https://cadenabackend.iworklab.com/",

  apiUrl:  "https://api.cadenaweb.com/api/v1",
  baseUrl: "https://api.cadenaweb.com/",

};
